<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success tw-text-center tw-ml-auto tw-w-full">
            <div class="tw-container tw-pb-6">
                <h2 class="tw-mt-10">Obrigado {{ $store.state.formName }}!</h2><br>
                <p>Assim que possível será contactado pela nossa equipa de forma a apresentar a nossa melhor proposta.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
@import '~@/assets/scss/partials/_fonts.scss';
.form-success {

    @screen lg {
        min-height: 750px;
    }

    h2 {
        font-family: $font_title;
        color: $white;
        font-size: 30px;
        font-weight: 700;

        @screen lg {
            font-size: 48px;
        }
    }

    p {
        @apply tw-text-center tw-text-white tw-z-30 tw-uppercase tw-font-normal;
        font-size: 22px;
        line-height: 26px;
        font-family: $font_title;
        font-weight: 400 !important;
        color: $white !important;

        @screen lg {
            @apply tw-text-3xl tw-mx-auto;
            line-height: 38px;
            max-width: 510px;
        }
    }
}

</style>
